<div *ngFor="let report of reports">

  <ng-container *ngFor="let finishedReport of report.finishedReports, let i = index">
    <div class="float-left">
      <button (click)="download(finishedReport, report)"
              [ngClass]="report.code"
              class="btn accent btn-left mt14">
        download {{ reportService.getReportName(report.code) }} {{ report?.year }}
      </button>
      <div class="small-text" style="padding-left: 73px; margin-top: -25px;">
        definitief gemaakt: {{ finishedReport.createdAt }}
      </div>

      <!--undo finish-->
      <div *ngIf="userService.isAdmin() && report.finished && report.finishedReports.length === i + 1"
           (click)="undoFinished(report)"
           class="small-text link" style="padding-left: 73px; margin-top: -8px;">
        ongedaan maken
      </div>
    </div>

    <div
      class="float-right"
      *ngIf="userService.isUser() && i == report.finishedReports.length - 1 && (report.code == 'RV' || report.code == 'ERV' || report.code == 'ERVO')">
      <button
        (click)="openOtherTransactions(report)"
        *ngIf="report.finished"
        class="btn magnify btn-left mt14">
        overige inkomsten en uitgaven {{ report?.year }}
      </button>
    </div>

    <div class="clearFix"></div>

  </ng-container>

  <button (click)="open(report)"
          *ngIf="!report.finished"
          [ngClass]="report.code"
          class="btn accent btn-left mt14">
    bewerk {{ reportService.getReportName(report.code) }} {{ report?.year }}
  </button>

</div>
